/**
 * @name getTypeof
 * @description 获取类型
 * @param {*} o
 */
/* eslint-disable */
export default function getTypeof(o){
    var t;
    return ((t = typeof(o)) == "object" ? o==null && "null" || Object.prototype.toString.call(o).slice(8,-1):t).toLowerCase();
}
